module.exports = __webpack_public_path__ + "static/media/img16.8dc604b3.jpg";